<template>
  <div class="company">
    <div v-loading="loading">
      <div class="ml20 mt20 f18 blue tem-header">
        <div class="cursor" @click="$router.back()"><i class="el-icon-back"></i> 返回</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.company {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
